import i18n from 'i18next';
import { reactI18nextModule } from 'react-i18next';
import backend from 'i18next-xhr-backend';
import { getUserLanguage } from '../helper/LanguageHelper';

const languageId = getUserLanguage();

const localLangId = localStorage.getItem('lang');
if (localLangId !== languageId) {
  localStorage.setItem('requestChangeLanguage', '1');
  localStorage.setItem('lang', languageId);
}

const i18nConfig = {
  lng: 'jp',
  fallbackLng: 'jp',
  keySeparator: false,
  interpolation: {
    escapeValue: false
  },
  react: {
    wait: true
  }
};

i18n
  .use(backend)
  .use(reactI18nextModule)
  .init(i18nConfig, () => {});

export default i18n;
